import { Helmet } from 'react-helmet';

const Seo = ({ data }) => (
  <Helmet>
    <title>{data?.title}</title>
    <meta name="description" content={data?.description} />
    <meta property="og:title" content={data?.og_title} />
    <meta property="og:type" content={data?.og_type} />
    <meta property="og:description" content={data?.og_description} />
    <meta http-equiv="Content-Security-Policy" 
      content="default-src 'self';
               script-src 'self' 
                  https://www.googletagmanager.com 
                  https://maps.googleapis.com 
                  https://bat.bing.com 
                  https://www.clickcease.com 
                  https://connect.facebook.net 
                  https://googleads.g.doubleclick.net 
                  https://www.google.com 
                  https://www.google-analytics.com
                  https://www.clarity.ms
                  https://www.gstatic.com
                  http://www.gstatic.com
                  https://www.googleadservices.com
                  'unsafe-inline' 
                  'unsafe-eval';
               style-src 'self' 'unsafe-inline' 
                  https://fonts.googleapis.com
                  https://cdnjs.cloudflare.com;
               img-src 'self' data: https:;
               font-src 'self' https://fonts.gstatic.com;
               connect-src 'self' 
                  https://admin.wefix-appliance.com 
                  https://admin.wefix-appliance.co 
                  https://admin.commercial-appliance-repair.com
                  https://admin.rapidresponse-repair.com
                  https://admin.local-appliance-repair.pro
                  https://admin.sameday-repair.com
                  https://www.google-analytics.com 
                  https://admin.sameday-hvac.com
                  https://*.facebook.com 
                  https://googleads.g.doubleclick.net
                  https://analytics.google.com
                  https://*.google-analytics.com
                  https://www.clarity.ms
                  https://www.google.com
                  https://google.com
                  https://d.clarity.ms
                  https://v.clarity.ms
                  https://*.clarity.ms
                  https://maps.googleapis.com
                  https://*.maps.googleapis.com
                  https://www.googleadservices.com
                  https://www.google.by;
               form-action 'self' https://admin.wefix-appliance.com;
               frame-src https://www.facebook.com
                  https://googleads.g.doubleclick.net
                  https://td.doubleclick.net
                  https://www.google.com
                  https://www.googletagmanager.com
                  https://www.googleadservices.com
                  https://www.google.by;"/>
  </Helmet>
);

export default Seo;
